// This pricing rule is intentionally limited to 2026. Seasonal sponsorship
// policies are decided annually and may be different in future years.
export const TU_BAV_SHIDDUCH_DATE = "2026-07-29";
export const TU_BAV_SHIDDUCH_USD_AMOUNT = 101;

// Tu B'Av begins the prior evening, but the existing sponsorship cutoff for
// the July 29 Dose is midnight at the start of July 29 in New York (EDT).
export const TU_BAV_SHIDDUCH_NOTICE_CUTOFF = "2026-07-29T04:00:00.000Z";

function getCalendarDateKey(value) {
  if (!value) {
    return "";
  }

  if (value instanceof Date && !isNaN(value)) {
    return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(
      2,
      "0",
    )}-${String(value.getDate()).padStart(2, "0")}`;
  }

  const match = String(value)
    .trim()
    .match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!match) {
    return "";
  }

  const [, month, day, year] = match;
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}

export function isTuBAvShidduchDedication(dedication) {
  return (
    dedication?.dedicationType?.name === "shidduch" &&
    getCalendarDateKey(dedication.day) === TU_BAV_SHIDDUCH_DATE
  );
}

export function getTuBAvShidduchAmount(localDoseAmount, usdDoseAmount) {
  const localAmount = Number(localDoseAmount);
  const ordinaryUsdAmount = Number(usdDoseAmount);

  if (
    !Number.isFinite(localAmount) ||
    !Number.isFinite(ordinaryUsdAmount) ||
    ordinaryUsdAmount <= 0
  ) {
    return 0;
  }

  return Math.round(
    (localAmount * TU_BAV_SHIDDUCH_USD_AMOUNT) / ordinaryUsdAmount,
  );
}

export function calculateDedicationAmount(
  dedication,
  localCurrencyAmounts,
  usdDoseAmount,
) {
  const ordinaryDoseAmount = Number(localCurrencyAmounts?.dose_amount ?? 0);
  const statusAmount = Number(localCurrencyAmounts?.status_amount ?? 0);
  const doseAmount = isTuBAvShidduchDedication(dedication)
    ? getTuBAvShidduchAmount(ordinaryDoseAmount, usdDoseAmount)
    : ordinaryDoseAmount;

  return (
    (dedication.isstatus ? statusAmount : 0) +
    (dedication.isdose ? doseAmount : 0)
  );
}

export function calculateDedicationsTotal(
  dedications,
  localCurrencyAmounts,
  usdDoseAmount,
  additionalAmount,
) {
  return (
    dedications
      .map(dedication =>
        calculateDedicationAmount(
          dedication,
          localCurrencyAmounts,
          usdDoseAmount,
        ),
      )
      .reduce((total, amount) => total + amount, 0) +
    Number(additionalAmount ?? 0)
  );
}

export function isTuBAvShidduchNoticeVisible(now = new Date()) {
  return now.getTime() < Date.parse(TU_BAV_SHIDDUCH_NOTICE_CUTOFF);
}
